import { gql } from '../../__generated__/gql'

export const COUPON_VALIDATION_QUERY = gql(`
  query couponValidation($code: String!, $planId: Int) {
    couponValidation(code: $code, planId: $planId) {
      couponCode
      name
    }
  }
`)
